import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import Button from "../components/ui/Button";

const sections = [
    {
        num: 1,
        title: "Aceptación de Términos",
        content:
            "Al acceder y utilizar este sitio web de venta de entradas, aceptas estos términos y condiciones en su totalidad. Si no estás de acuerdo con alguno de estos términos, no debes usar este sitio.",
    },
    {
        num: 2,
        title: "Licencia de Uso",
        content:
            "Se te otorga una licencia limitada, no exclusiva e intransferible para usar este sitio web únicamente para comprar entradas para eventos. No puedes reproducir, distribuir o transmitir el contenido sin nuestro permiso previo.",
    },
    {
        num: 3,
        title: "Compra de Entradas",
        items: [
            "Las entradas son intransferibles y no pueden ser revendidas sin autorización",
            "El comprador es responsable de proporcionar información precisa",
            "Las entradas son válidas solo para el evento y fecha especificada",
            "Los cambios en las entradas están sujetos a disponibilidad y pueden tener cargos adicionales",
        ],
    },
    {
        num: 4,
        title: "Pago",
        content:
            "Todos los pagos se procesan de forma segura a través de Stripe o Redsys, según el método de pago disponible o seleccionado. Al completar una compra, aceptas los términos de pago y confirmas que tienes la autoridad para usar la forma de pago proporcionada.",
    },
    {
        num: 5,
        title: "Reembolsos y Cancelaciones",
        content:
            "Los reembolsos están sujetos a la política específica del evento. Algunos eventos pueden ofrecer reembolsos completos si se cancelan antes de una fecha determinada, mientras que otros pueden ser no reembolsables.",
    },
    {
        num: 6,
        title: "Limitación de Responsabilidad",
        content:
            "No somos responsables por lesiones, pérdidas o daños que puedan ocurrir durante el evento. El asistente asume toda la responsabilidad por su seguridad y bienestar.",
    },
    {
        num: 7,
        title: "Cookies técnicas",
        content:
            "Para permitir funcionalidades esenciales del proceso de compra, este sitio utiliza únicamente cookies técnicas y necesarias (por ejemplo, sesión y carrito). No se usan cookies de analítica, publicidad ni personalización no esencial.",
        link: {
            to: "/privacy",
            text: "Consulta la Política de Privacidad para más detalle.",
        },
    },
    {
        num: 8,
        title: "Cambios en los Términos",
        content:
            "Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigencia inmediatamente después de su publicación en este sitio.",
    },
];

export default function TermsPage() {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
            className="max-w-4xl mx-auto px-4 py-8"
        >
            <div className="mb-8">
                <Link to="/">
                    <Button variant="ghost" size="sm" icon={FiArrowLeft}>
                        Volver
                    </Button>
                </Link>
            </div>

            <div className="mb-10">
                <h1 className="text-4xl font-display font-bold text-white mb-2">
                    Términos y Condiciones
                </h1>
                <p className="text-slate-400">
                    Última actualización: Marzo 2026
                </p>
            </div>

            <div className="space-y-4">
                {sections.map((section, idx) => (
                    <motion.section
                        key={section.num}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: idx * 0.05 }}
                        className="bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-lg p-6 hover:shadow-md transition"
                    >
                        <div className="flex items-start gap-4 mb-4">
                            <div className="flex-shrink-0 w-10 h-10 bg-primary-500/20 text-primary-400 rounded-lg flex items-center justify-center font-bold text-lg">
                                {section.num}
                            </div>
                            <h2 className="text-lg font-bold text-white">
                                {section.title}
                            </h2>
                        </div>
                        {section.content && (
                            <p className="text-slate-400 leading-relaxed ml-14">
                                {section.content}
                            </p>
                        )}
                        {section.link && (
                            <p className="text-slate-400 leading-relaxed ml-14 mt-2">
                                <Link
                                    to={section.link.to}
                                    className="text-primary-400 hover:underline font-semibold"
                                >
                                    {section.link.text}
                                </Link>
                            </p>
                        )}
                        {section.items && (
                            <ul className="list-disc list-inside text-slate-400 space-y-2 ml-4">
                                {section.items.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                        )}
                    </motion.section>
                ))}
            </div>

            <div className="mt-12 pt-8 border-t border-slate-700/50">
                <p className="text-slate-400 text-sm">
                    <span className="font-semibold">Última actualización:</span>{" "}
                    {new Date().toLocaleDateString("es-ES")}
                </p>
                <p className="text-slate-400 text-sm mt-3">
                    Si tienes preguntas sobre estos términos, contáctanos en{" "}
                    <a
                        href="mailto:entradas@pulseticket.es"
                        className="text-primary-400 hover:underline font-semibold"
                    >
                        entradas@pulseticket.es
                    </a>
                </p>
            </div>
        </motion.div>
    );
}
